// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;
}

.tour-popup {
  position: fixed;
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  min-width: 320px;
  text-align: left;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  z-index: 10001;
  pointer-events: all;
  font-family: 'Lato', sans-serif;
  transition: all 0.3s ease;
}

.tour-highlight {
  position: relative;
  z-index: 9998;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 1), 0 0 0 9999px rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  transition: all 0.3s ease;
  /* background: #fff; */
}

.tour-title {
  margin: 0 0 12px 0;
  color: #184A61;
  font-size: 18px;
  font-weight: 700;
}

.tour-description {
  margin: 0 0 16px 0;
  color: #184A61;
  font-size: 18px;
  line-height: 1.5;
}

.tour-counter {
  font-size: 18px;
  color: #184A61;
  margin-bottom: 12px;
  font-weight: 500;
  position: absolute;
  margin-top: 10px;
}

.tour-actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
}

.tour-button {
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border: none;
}

.tour-button-skip {
  background: transparent;
    border: 1px solid #d96b73;
    color: #184A61;
    position: absolute;
    right: 130px;
    bottom: 22px;
    height: 49px;
}
.tour-button {
  padding: 12px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #DA6C74;
}

.tour-button-previous {
  background: transparent;
  border: 1px solid #DA6C74;
  color: #184A61;
}

.tour-button-next {
  background: #DA6C74;
  color: white;
  gap: 4px !important;
}

.tour-button-group {
  display: flex;
  gap: 12px;
}
.tour-popup::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

.tour-arrow-top::before {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent white transparent;
}

.tour-arrow-bottom::before {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 10px 10px 0 10px;
  border-color: white transparent transparent transparent;
}

.tour-arrow-left::before {
  left: -10px;
  top: 30px;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

.tour-arrow-right::before {
  right: -10px;
  top: 30px;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

`, "",{"version":3,"sources":["webpack://./src/components/ProductTour/TourSteps.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6EAA6E;EAC7E,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;IACrB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,uDAAuD;AACzD","sourcesContent":[".tour-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.tour-popup {\n  position: fixed;\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  max-width: 400px;\n  min-width: 320px;\n  text-align: left;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  z-index: 10001;\n  pointer-events: all;\n  font-family: 'Lato', sans-serif;\n  transition: all 0.3s ease;\n}\n\n.tour-highlight {\n  position: relative;\n  z-index: 9998;\n  box-shadow: 0 0 0 4px rgba(255, 255, 255, 1), 0 0 0 9999px rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  /* background: #fff; */\n}\n\n.tour-title {\n  margin: 0 0 12px 0;\n  color: #184A61;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.tour-description {\n  margin: 0 0 16px 0;\n  color: #184A61;\n  font-size: 18px;\n  line-height: 1.5;\n}\n\n.tour-counter {\n  font-size: 18px;\n  color: #184A61;\n  margin-bottom: 12px;\n  font-weight: 500;\n  position: absolute;\n  margin-top: 10px;\n}\n\n.tour-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tour-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n}\n\n.tour-button-skip {\n  background: transparent;\n    border: 1px solid #d96b73;\n    color: #184A61;\n    position: absolute;\n    right: 130px;\n    bottom: 22px;\n    height: 49px;\n}\n.tour-button {\n  padding: 12px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #DA6C74;\n}\n\n.tour-button-previous {\n  background: transparent;\n  border: 1px solid #DA6C74;\n  color: #184A61;\n}\n\n.tour-button-next {\n  background: #DA6C74;\n  color: white;\n  gap: 4px !important;\n}\n\n.tour-button-group {\n  display: flex;\n  gap: 12px;\n}\n.tour-popup::before {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n}\n\n.tour-arrow-top::before {\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 0 10px 10px 10px;\n  border-color: transparent transparent white transparent;\n}\n\n.tour-arrow-bottom::before {\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 10px 10px 0 10px;\n  border-color: white transparent transparent transparent;\n}\n\n.tour-arrow-left::before {\n  left: -10px;\n  top: 30px;\n  border-width: 10px 10px 10px 0;\n  border-color: transparent white transparent transparent;\n}\n\n.tour-arrow-right::before {\n  right: -10px;\n  top: 30px;\n  border-width: 10px 0 10px 10px;\n  border-color: transparent transparent transparent white;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
